import { IApiRestFormulariosClient } from 'src/model/candidato-api'
import angular from 'angular'
import { AccesoDatos } from '../../comun/services/acceso-datos'

export class TestService {
  constructor(
    private $log: ng.ILogService,
    private AccesoDatos: AccesoDatos
  ) {}

  testFormularios() {
    return this.AccesoDatos.Menu_CLIENT.menuInicio()
  }
}

angular.module('candidato').service('TestService', TestService)
